import React, { useState, useEffect } from 'react';
import './TravellerIdentity.css';

const mockData = [
  {
    name: 'ABC',
    dob: '24/02/2000',
    passport: 'ABCD1234',
    gender: 'Male',
    id: 'ABC123B',
    uploadedDocs: {
      passport: { status: 'none', fileName: '', uploadDate: null },
      panCard: { status: 'failed', fileName: 'dafsgeu.pdf', uploadDate: null },
      adhaarCard: { status: 'success', fileName: 'dafsgeu.pdf', uploadDate: new Date() },
      incomeTax: { status: 'none', fileName: '', uploadDate: null },
    }
  },
  {
    name: 'ABC',
    dob: '24/02/2000',
    passport: 'ABCD1234',
    gender: 'Male',
    id: 'ABC123B',
    uploadedDocs: {
      passport: { status: 'none', fileName: '', uploadDate: null },
      panCard: { status: 'failed', fileName: 'dafsgeu.pdf', uploadDate: null },
      adhaarCard: { status: 'success', fileName: 'dafsgeu.pdf', uploadDate: new Date() },
      incomeTax: { status: 'none', fileName: '', uploadDate: null },
    }
  }
];

const TravellerDetails = () => {
  const [travellerData, setTravellerData] = useState([]);
  const [showTooltip, setShowTooltip] = useState({ traveller: -1, doc: '' });
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/travellers');
        const data = await response.json();
        setTravellerData(data);
      } catch (error) {
        setTravellerData(mockData);
      }
    };
    fetchData();
  }, []);

  const handleFileChange = async (e, docType, index) => {
    const file = e.target.files[0];
    if (file) {
      // Update status to uploading
      setTravellerData(prevData =>
        prevData.map((traveller, i) =>
          i === index
            ? {
                ...traveller,
                uploadedDocs: {
                  ...traveller.uploadedDocs,
                  [docType]: {
                    status: 'uploading',
                    fileName: file.name,
                    uploadDate: null
                  }
                }
              }
            : traveller
        )
      );

      try {
        // Simulate API call for file upload
        const formData = new FormData();
        formData.append('file', file);
        formData.append('docType', docType);
        formData.append('travellerId', index);

        // Simulate upload delay
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Simulate random success/failure (80% success rate)
        const uploadSuccess = Math.random() > 0.2;

        if (uploadSuccess) {
          // Update status to success
          setTravellerData(prevData =>
            prevData.map((traveller, i) =>
              i === index
                ? {
                    ...traveller,
                    uploadedDocs: {
                      ...traveller.uploadedDocs,
                      [docType]: {
                        status: 'success',
                        fileName: file.name,
                        uploadDate: new Date()
                      }
                    }
                  }
                : traveller
            )
          );
        } else {
          // Update status to failed
          setTravellerData(prevData =>
            prevData.map((traveller, i) =>
              i === index
                ? {
                    ...traveller,
                    uploadedDocs: {
                      ...traveller.uploadedDocs,
                      [docType]: {
                        status: 'failed',
                        fileName: file.name,
                        uploadDate: null
                      }
                    }
                  }
                : traveller
            )
          );
        }
      } catch (error) {
        // Handle upload error
        setTravellerData(prevData =>
          prevData.map((traveller, i) =>
            i === index
              ? {
                  ...traveller,
                  uploadedDocs: {
                    ...traveller.uploadedDocs,
                    [docType]: {
                      status: 'failed',
                      fileName: file.name,
                      uploadDate: null
                    }
                  }
                }
              : traveller
          )
        );
      }
    }
  };

  const renderDocumentButton = (traveller, docType, index, displayName) => {
    const docInfo = traveller.uploadedDocs[docType];
    const status = docInfo?.status || 'none';
    const fileName = docInfo?.fileName || '';

    const getButtonClass = () => {
      switch (status) {
        case 'success':
          return 'doc-button uploaded';
        case 'failed':
          return 'doc-button failed';
        case 'uploading':
          return 'doc-button uploading';
        default:
          return 'doc-button';
      }
    };

    const getButtonText = () => {
      switch (status) {
        case 'success':
          return fileName;
        case 'failed':
          return fileName;
        case 'uploading':
          return 'Uploading...';
        default:
          return displayName;
      }
    };

    const getTextClass = () => {
      switch (status) {
        case 'success':
          return 'file-name-success';
        case 'failed':
          return 'file-name-failed';
        case 'uploading':
          return 'file-name-uploading';
        default:
          return '';
      }
    };

    const getIconClass = () => {
      switch (status) {
        case 'uploading':
          return 'loading-icon';
        default:
          return 'download-icon';
      }
    };

    return (
      <div className={getButtonClass()}>
        <span className={getTextClass()}>{getButtonText()}</span>
        <input
          type="file"
          onChange={(e) => handleFileChange(e, docType, index)}
          id={`${docType}-input-${index}`}
          className="bd-file-input"
          disabled={status === 'uploading'}
        />
        <label 
          htmlFor={`${docType}-input-${index}`} 
          className={getIconClass()}
          onMouseEnter={() => {
            if (status === 'failed') {
              setShowTooltip({ traveller: index, doc: docType });
            }
          }}
          onMouseLeave={() => setShowTooltip({ traveller: -1, doc: '' })}
        >
          {status === 'failed' && showTooltip.traveller === index && showTooltip.doc === docType && (
            <div className="tooltip">
              <span>Upload again</span>
              <div className="tooltip-arrow"></div>
            </div>
          )}
        </label>
      </div>
    );
  };

  return (
    <>
      <div className='traveller-cont'>
        <div className='traveller-cont-tit'>Traveller's Details</div>
        {travellerData.map((traveller, index) => (
          <div key={index} style={{padding:'10px'}}>
            <div className="traveller-section">
              <div className="traveller-header">
                <h3 className="traveller-title">
                  Traveller {index + 1} <span className="traveller-subtitle">(Primary Customer)</span>
                </h3>
              </div>
              
              <div className="bd-form-fields">
                <div className="bd-form-group">
                  <label className="form-label">Name</label>
                  <input type="text" value={traveller.name || ''} readOnly className="bd-form-input" />
                </div>
                <div className="bd-form-group">
                  <label className="form-label">DOB</label>
                  <input type="text" value={traveller.dob || ''} readOnly className="bd-form-input" />
                </div>
                <div className="bd-form-group">
                  <label className="form-label">Passport no.</label>
                  <input type="text" value={traveller.passport || ''} readOnly className="bd-form-input" />
                </div>
                <div className="bd-form-group">
                  <label className="form-label">Gender</label>
                  <input type="text" value={traveller.gender || ''} readOnly className="bd-form-input" />
                </div>
                <div className="bd-form-group">
                  <label className="form-label">Pan/ Adhaar no.</label>
                  <input type="text" value={traveller.id || ''} readOnly className="bd-form-input" />
                </div>
              </div>
              
              <div className="document-buttons">
                {renderDocumentButton(traveller, 'passport', index, 'Passport')}
                {renderDocumentButton(traveller, 'panCard', index, 'Pan Card')}
                {renderDocumentButton(traveller, 'adhaarCard', index, 'Adhaar Card')}
                {renderDocumentButton(traveller, 'incomeTax', index, 'Income tax Statement')}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TravellerDetails;